import React from "react";
import {
  Dashboard
} from "../../app/modules/Dashboard/pages/Dashboard";

export function DashboardPage() {
  return <Dashboard />;
}
